module.exports = __webpack_public_path__ + "img/logo-sistarum.af8083c7.png";